import { render, staticRenderFns } from "./ModalEventEditor.vue?vue&type=template&id=2abafeb8&scoped=true&"
import script from "./ModalEventEditor.vue?vue&type=script&lang=js&"
export * from "./ModalEventEditor.vue?vue&type=script&lang=js&"
import style0 from "./ModalEventEditor.vue?vue&type=style&index=0&id=2abafeb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abafeb8",
  null
  
)

export default component.exports